/**
 *=================================== AUTHOR : MUSKAN KHAN===========================
 * ===================================DATE : 10 OCT 2024========================
 */
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState } from "react";

const ProductCategory = () => {
  const navigate = useNavigate();
  const [categoryName, setCategoryName] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();

    toast.success("Category saved successfully!");
    setCategoryName("");
    setSelectedOption("");
    navigate("/productcategoryview");
  };

  const handleCancel = () => {
    navigate("/productcategoryview");
  };

  return (
    <Container>
      <Row>
        <Col></Col>
        <Col lg={8} className="pb-1 pt-2">
          <Link className="nav-link" to="/productview">
            Home <i className="fa-solid fa-chevron-right"></i>{" "}
            <div style={{ color: "#23468c", display: "inline" }}>
              Product Category
            </div>
          </Link>
        </Col>
        <Col></Col>
      </Row>
      <Row>
        <Col></Col>
        <Col lg={8}>
          <Form className="mt-3" noValidate onSubmit={handleSubmit}>
            <Row className="view-form-header align-items-center">
              <Col lg={8}></Col>
              <Col lg={4} className="d-flex justify-content-end">
                <Button className="btn-sm mx-2" type="submit">
                  Save
                </Button>
                <Button
                  className="btn-sm"
                  variant="danger"
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
            <Row className="ibs-edit-form pb-3">
              <Row className="mb-3">
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicName">
                    <Form.Label>Category Name</Form.Label>
                    <Form.Control
                      required
                      style={{ height: "36px" }}
                      type="text"
                      name="name"
                      placeholder="--Enter Category Name--"
                      value={categoryName}
                      onChange={(e) => setCategoryName(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3" controlId="formBasicSelect">
                    <Form.Label>Select Option</Form.Label>
                    <Form.Select
                      required
                      value={selectedOption}
                      onChange={(e) => setSelectedOption(e.target.value)}
                      style={{ height: "36px" }}
                      name="options"
                    >
                      <option value="">--Select--</option>
                      <option value="option1">Option 1</option>
                      <option value="option2">Option 2</option>
                      <option value="option3">Option 3</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Row>
          </Form>
        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
};

export default ProductCategory;
